export class MockNotificationService {
  getNotifications = jasmine.createSpy('getNotifications');
  getNotificationsCount = jasmine.createSpy('getNotificationsCount');
  deleteNotification = jasmine.createSpy('deleteNotification');
  toggleReadNotification = jasmine.createSpy('toggleReadNotification');
}
